import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class DepositCardSettings extends BaseProductSettings {
}